export default {
    title: 'Регистрация',
    invitation_title: 'Приглашение от {caller}',
    finalize_profile: 'Завершите настройку своего профиля',
    subtitle: 'Уже есть аккаунт?',
    sign_in: 'Войти',
    messages: {
        register_success: 'Регистрация завершена! Пожалуйста, подтвердите email, чтобы продолжить.',
        invite_success: 'Приглашение выполнено! Пожалуйста, войдите, чтобы продолжить.',
    },
}
